<div>
    <p class="title">Are you sure to clear player app data for the device(s)?</p>
    <div class="content">{{ _monitorDeviceNames }}</div>
</div>